import { LocaleLink } from "@ct-react/locale";
import RatioImage from "./medias/ratio-image";
import { NewsEntry } from "../contexts/news";
import Skeleton from "react-loading-skeleton";
import "./post-card.scss";
import { buildPageUrl } from "@shared/url";

type Props = {
  data:NewsEntry | null,
}

function PostCard({ data }: Props) {

  if(data == null){
    return(
    <article className="post-card skeleton">
      <Skeleton height="100%" width="100%"/>
    </article>)
  };

  return (
    <article className="post-card">
      <LocaleLink
        to={`/actualites/${buildPageUrl(data.data["news-title"])}?refId=${data.id}`}
        aria-label="Lisez cet article pour en savoir plus"
      />
      <h3>{data.data["news-title"]}</h3>
      <RatioImage source={data.data["news-image"].assets}
                  alt={data.data["news-image"].alternativeText || data.data["news-title"]}/>
    </article>
  );
}

export default PostCard;
